export default __webpack_public_path__ + "static/media/rfid.91e62c63.png";